import React from 'react';
import { useThemeClasses } from '../../../hooks/useThemeClasses';

const ZONE_LABELS = {
  bonnet: 'Bonnet',
  bumper_front: 'Front bumper',
  bumper_rear: 'Rear bumper',
  fender_fl: 'Front left fender',
  fender_fr: 'Front right fender',
  door_fl: 'Front left door',
  door_fr: 'Front right door',
  door_rl: 'Rear left door',
  door_rr: 'Rear right door',
  headlight_l: 'Headlight',
  headlight_r: 'Headlight',
  tailgate: 'Tailgate',
};

export default function PanelDamageMap({ damageZone = 'bumper_front', compact = false }) {
  const { isDark, sc } = useThemeClasses();
  const active = damageZone || 'bumper_front';
  const label = ZONE_LABELS[active] || 'Panel';

  const isActive = (zone) => active === zone;

  return (
    <section className={`${sc('pdpPanel')} ${compact ? 'p-3 sm:p-4' : ''}`}>
      <p className={`text-[11px] font-bold uppercase tracking-[0.15em] ${isDark ? 'text-slate-500' : 'text-slate-500'}`}>
        Affected panel
      </p>
      <p className={`mt-1 text-sm font-medium ${isDark ? 'text-slate-300' : 'text-slate-800'}`}>{label}</p>

      <div className={`flex justify-center ${compact ? 'mt-2' : 'mt-4'}`}>
        <svg
          viewBox="0 0 200 120"
          className={`w-full max-w-xs ${compact ? 'h-20' : 'h-28'} ${isDark ? 'text-slate-600' : 'text-slate-300'}`}
          aria-label={`Car diagram — ${label} highlighted`}
        >
          <path
            d="M40 55 Q50 20 100 18 Q150 20 160 55 L155 95 Q100 105 45 95 Z"
            fill="currentColor"
            opacity="0.25"
          />
          <ellipse cx="55" cy="58" rx="12" ry="8" fill="currentColor" opacity="0.35" />
          <ellipse cx="145" cy="58" rx="12" ry="8" fill="currentColor" opacity="0.35" />
          {isActive('bonnet') && (
            <path d="M70 28 Q100 22 130 28 L125 48 Q100 44 75 48 Z" fill="#f59e0b" opacity="0.85" />
          )}
          {isActive('bumper_front') && (
            <path d="M42 72 Q100 88 158 72 L155 95 Q100 105 45 95 Z" fill="#f59e0b" opacity="0.85" />
          )}
          {isActive('bumper_rear') && (
            <path d="M48 18 Q100 12 152 18 L150 28 Q100 24 50 28 Z" fill="#f59e0b" opacity="0.85" />
          )}
          {(isActive('fender_fl') || isActive('door_fl')) && (
            <rect x="38" y="42" width="22" height="38" rx="4" fill="#f59e0b" opacity="0.85" />
          )}
          {(isActive('fender_fr') || isActive('door_fr')) && (
            <rect x="140" y="42" width="22" height="38" rx="4" fill="#f59e0b" opacity="0.85" />
          )}
          {(isActive('headlight_l') || isActive('headlight_r')) && (
            <ellipse
              cx={isActive('headlight_r') ? 145 : 55}
              cy="58"
              rx="14"
              ry="10"
              fill="#f59e0b"
              opacity="0.9"
            />
          )}
          {isActive('tailgate') && (
            <path d="M75 20 Q100 16 125 20 L122 32 Q100 30 78 32 Z" fill="#f59e0b" opacity="0.85" />
          )}
        </svg>
      </div>
    </section>
  );
}
